var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarNone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "mix-1",
    d: "M4 0.5H16C17.3789 0.5 18.5 1.62114 18.5 3V23C18.5 23.2739 18.2739 23.5 18 23.5H2C1.72614 23.5 1.5 23.2739 1.5 23V3C1.5 1.62114 2.62114 0.5 4 0.5Z",
    fill: "#EAEEF2",
    stroke: "#D0D7DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarNone);
export default __webpack_public_path__ + "static/media/bar-none.9828e997d1b9769e388f5397c030fdb3.svg";
export { ForwardRef as ReactComponent };